import React from 'react';

// Premium trust/feature tile. Supports a `tone` for subtle per-card surface
// variation (mint / cream / pale-green / white+border) so a grid of these
// doesn't read as identical white boxes — differences stay at the "extremely
// subtle pastel" intensity the design system calls for, never a rainbow.
const TONE_STYLES = {
  mint: 'bg-gradient-to-br from-emerald-50 to-white border-emerald-100',
  cream: 'bg-gradient-to-br from-amber-50/60 to-white border-amber-100/70',
  sage: 'bg-emerald-50/70 border-emerald-100',
  white: 'bg-white border-emerald-100/70',
};

const FeatureCard = ({ icon: Icon, title, description, stat, tone = 'white' }) => (
  <div
    className={`card-hover group relative rounded-2xl border shadow-soft p-6 sm:p-7 overflow-hidden ${TONE_STYLES[tone] || TONE_STYLES.white}`}
  >
    <div className="absolute top-0 left-0 h-1 w-full bg-gradient-primary opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
    <div
      className="absolute -bottom-8 -right-8 w-24 h-24 bg-emerald-200/20 rounded-full blur-2xl pointer-events-none"
      aria-hidden="true"
    />
    {stat ? (
      <p className="relative serif text-4xl text-emerald-700 mb-1">{stat}</p>
    ) : (
      <div className="relative w-12 h-12 rounded-xl bg-white/80 shadow-soft flex items-center justify-center mb-4 group-hover:bg-white transition-colors">
        <Icon size={22} className="text-emerald-700" aria-hidden="true" />
      </div>
    )}
    <h3 className="relative font-bold text-emerald-950 mb-1.5">{title}</h3>
    {description && <p className="relative text-sm text-ink-secondary leading-relaxed">{description}</p>}
  </div>
);

export default FeatureCard;
